module.exports = "/_next/static/images/6b8476748092b2eaec9726a9043cbaf1-hands-holding-cards-lg@1x.jpg";